
import { Component, Prop, Vue } from 'vue-property-decorator'

/**
 * セレクト系ボタン用矢印アイコン
 */
@Component
export default class SelectArrowBase extends Vue {
  /** 矢印色指定(指定がない場合黒) */
  @Prop({ default: '--color-default__text' })
  private arrowColor?: string

  /**
   * アイコンの色を設定する
   *
   * @returns css：カラー変数文字列
   */
  private get setStyle(): { [key: string]: string } {
    return {
      '--arrow-color': `var(${this.arrowColor})`,
    }
  }
}
